import React, { useEffect, useState } from "react";
import { Routes, Route, NavLink, useNavigate } from "react-router-dom";
import { Gamepad2, Link2, Search, FileText, MessageSquareHeart, LogOut, ExternalLink } from "lucide-react";
import { adminApi } from "./api";
import GamesTab from "./GamesTab";
import SettingsTab from "./SettingsTab";
import { useData } from "../../data/DataContext";

const NAV = [
  ["", "Games", Gamepad2],
  ["links", "Links & Brand", Link2],
  ["seo", "SEO", Search],
  ["content", "Content", FileText],
  ["reviews", "Reviews", MessageSquareHeart],
];

export default function AdminPanel() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const { reload } = useData();

  useEffect(() => {
    adminApi.me().then(setUser).catch(() => navigate("/admin/login"));
  }, [navigate]);

  const logout = async () => {
    await adminApi.logout().catch(() => {});
    localStorage.removeItem("admin_token");
    navigate("/admin/login");
  };

  if (!user) return <div className="py-32 text-center text-emerald-50/60 font-bold">Checking session...</div>;

  return (
    <div data-testid="admin-panel" className="min-h-screen flex flex-col md:flex-row">
      <aside className="md:w-60 shrink-0 bg-[#011f0d] border-b md:border-b-0 md:border-r border-[#1c5f35] md:min-h-screen">
        <div className="px-4 py-4 flex items-center justify-between md:block">
          <div className="flex items-center gap-2.5">
            <img src="/images/games/maha-games-logo-w128.webp" alt="" className="w-9 h-9 rounded-lg" />
            <div>
              <p className="text-white font-extrabold leading-tight">Admin Panel</p>
              <p className="text-[11px] text-emerald-50/50 truncate max-w-[140px]">{user.email}</p>
            </div>
          </div>
          <button data-testid="admin-logout" onClick={logout} className="md:hidden text-emerald-50/70 hover:text-[#ffb224]"><LogOut size={18} /></button>
        </div>
        <nav className="flex md:flex-col gap-1 px-3 pb-3 overflow-x-auto">
          {NAV.map(([path, label, Icon]) => (
            <NavLink key={path} to={`/admin/${path}`} end={path === ""} data-testid={`admin-nav-${path || "games"}`} className={({ isActive }) => `flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-bold whitespace-nowrap transition-colors ${isActive ? "bg-[#ffb224] text-[#062a13]" : "text-emerald-50/75 hover:bg-white/5"}`}>
              <Icon size={16} /> {label}
            </NavLink>
          ))}
          <a href="/" target="_blank" rel="noreferrer" className="hidden md:flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-bold text-emerald-50/75 hover:bg-white/5"><ExternalLink size={16} /> View site</a>
          <button data-testid="admin-logout-desktop" onClick={logout} className="hidden md:flex items-center gap-2 px-3 py-2 rounded-xl text-sm font-bold text-emerald-50/75 hover:bg-white/5 text-left"><LogOut size={16} /> Logout</button>
        </nav>
      </aside>
      <div className="flex-1 p-4 sm:p-6 max-w-5xl">
        <Routes>
          <Route index element={<GamesTab onChanged={reload} />} />
          <Route path="links" element={<SettingsTab section="links" onChanged={reload} />} />
          <Route path="seo" element={<SettingsTab section="seo" onChanged={reload} />} />
          <Route path="content" element={<SettingsTab section="content" onChanged={reload} />} />
          <Route path="reviews" element={<SettingsTab section="reviews" onChanged={reload} />} />
        </Routes>
      </div>
    </div>
  );
}
